import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';

function TablaProductoMuestreo(props) {

    const { api = undefined } = props
    let fc_31ProductosMuestreoMap = props.productosMap
    let otrainstalacion = props.propia
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdleProductoMuestreo, handdleRemoveProductosPrevMuestreo,
        handdleEditProductosPrevMuestreo, productosMuestreo } = api
    const [id, setId] = React.useState()
    const [numerolote, setNumeroLote] = React.useState('')
    const [volumen, setVolumen] = React.useState('')
    const [contenidoalcoholico, setContenidoAlcoholico] = React.useState('')
    const [analisis, setAnalisis] = React.useState('')
    const [ajuste, setAjuste] = React.useState(false)
    const [pmezcla, setMezcla] = React.useState(false)
    const [informacionadicional, setInformacionAdicional] = React.useState('')
    let idsParaAsignar = []

    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = []

    columns = [
        {
            field: 'numerolote', headerName: 'No. de lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 200,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerolote}`} arrow>
                        <label>{`${params.row.numerolote} `}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'volumen', headerName: 'Volumen (Litros)', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 170, },

        {
            field: 'contenidoalcoholico', headerName: '% Alc. Vol.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 170,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.contenidoalcoholico}`} arrow>
                        <label>{`${params.row.contenidoalcoholico} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'analisis', headerName: 'Análisis de laboratorio', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 170,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.analisis}`} arrow>
                        <label>{`${params.row.analisis} `}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'ajuste', headerName: 'Ajuste', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 80, },
        { field: 'mezcla', headerName: 'Mezcla', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 80, },

        {
            field: 'informacionadicional', headerName: 'Información Adicional', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 250,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.informacionadicional}`} arrow>
                        <label>{`${params.row.informacionadicional} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 200,
            renderCell: (params) => (

                <Fragment>
                    {fc_31ProductosMuestreoMap?.length > 0 ? (
                        <Fragment>

                            {/* // <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button> */}
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                        </Fragment>)}
                </Fragment>

            )
        },
    ]

    const botonEliminar = async (params) => {
        handdleRemoveProductosPrevMuestreo({ data: params.row })
    }

    const botonGuardar = async () => {
        if (/*contenidoalcoholico > 34 && contenidoalcoholico < 56 &&*/ numerolote.length > 0 && volumen.length>0 /*&& (ajuste || pmezcla)*/) {
            let dato = {
                id: id, numerolote: numerolote, volumen: volumen, contenidoalcoholico: contenidoalcoholico,
                informacionadicional: informacionadicional, 
                ajuste: ajuste === true ? '✔' : '', mezcla: pmezcla === true ? '✔' : '',
                analisis: analisis
            }
            
            handdleEditProductosPrevMuestreo(dato)
            setNumeroLote('')
            setVolumen('')
            setContenidoAlcoholico('')
            setInformacionAdicional('')
            setAnalisis('')
            setAjuste(false)
            setMezcla(false)
            setEditar(false)
            setproductoMap([])
        } else {
            setvalidacion(true)
        }
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setNumeroLote(params.row.numerolote)
        setVolumen(params.row.volumen)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setInformacionAdicional(params.row.informacionadicional)
        setAnalisis(params.row.analisis)
        if (params.row.ajuste === '✔') setAjuste(true)
        else setAjuste(false)
        if (params.row.mezcla === '✔') setMezcla(true)
        else setMezcla(false)
        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(productosMuestreo)
    React.useEffect(() => {
        setRows(productosMuestreo)
    }, [productosMuestreo])

    const botonAgregar = async () => {
        if (/*contenidoalcoholico > 34 && contenidoalcoholico < 56 &&*/ numerolote.length > 0 && volumen.length>0 /*&& (ajuste || pmezcla)*/) {
            let dato = {
                id: uuidv4(), numerolote: numerolote, volumen: volumen, contenidoalcoholico: contenidoalcoholico,
                informacionadicional: informacionadicional, ajuste: ajuste === true ? '✔' : '', mezcla: pmezcla === true ? '✔' : '',
                analisis: analisis
            }
            handdleProductoMuestreo(dato)
            setNumeroLote('')
            setVolumen('')
            setContenidoAlcoholico('')
            setInformacionAdicional('')
            setAjuste(false)
            setMezcla(false)
            setAnalisis('')
        } else {
            setvalidacion(true)
        }
    }
    const botonCancelar = async () => {
        setproductoMap([])
        setNumeroLote('')
        setVolumen('')
        setContenidoAlcoholico('')
        setInformacionAdicional('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        const filtro = fc_31ProductosMuestreoMap.filter(anexo => anexo.idfc31_anexomuestreo === params.row.idfc31_anexomuestreo)
        setproductoMap(filtro[0])
        if (params.row.idfc31_anexomuestreo) setId(params.row.idfc31_anexomuestreo)
        else setId(params.row.idfc31_anexomuestreo)
        setNumeroLote(params.row.numerolote)
        setVolumen(params.row.volumen)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setInformacionAdicional(params.row.informacionadicional)
        setAnalisis(params.row.analisis)
        if (params.row.ajuste === '✔') setAjuste(true)
        else setAjuste(false)
        if (params.row.mezcla === '✔') setMezcla(true)
        else setMezcla(false)
        setEditar(true)
    }

    /*const evento = async (params) => {
        let filas = []
        for (const i in idsParaAsignar) {
            let filtro = rows.filter(row => row.id === idsParaAsignar[i])
            filas.push(filtro[0])
        }
        let concatLotes = ''
        let sumaVolumen = 0
        let sumaContenido = 0
        let concatInfo = ''
        let productoSeleccionado = []
        for (const i in filas) {
            concatLotes += filas[i].numerolote + ', '
            sumaVolumen += Number(filas[i].volumen)
            sumaContenido += Number(filas[i].contenidoalcoholico)
            concatInfo += filas[i].informacionadicional + ', '
            productoSeleccionado.push({
                id: filas[i].id,
                numerolote: filas[i].numerolote, volumen: filas[i].volumen,
                contenidoalcoholico: filas[i].contenidoalcoholico, informacionadicional: filas[i].informacionadicional
            })
        }
        //let promedioVolumen = sumaVolumen / filas.length
        let promedioContenido = sumaContenido / filas.length
        let subLotes = concatLotes.substring(0, concatLotes.length - 2)
        let subInfo = concatInfo.substring(0, concatInfo.length - 2)
        let total = { id: uuidv4(), numerolote: subLotes, volumen: sumaVolumen, contenidoalcoholico: promedioContenido, informacionadicional: subInfo }
        //handdleProductoMezcla(total)
        handdleProductoSeleccionados(productoSeleccionado, total)
    }*/

    return (
        <>
            <FormGroup>
                <div className='row align-items-center'>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="text" min='0' className={`form-control ${productoMap?.muestreocheck !== undefined ? (productoMap?.muestreocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de cajas'
                                value={numerolote} onChange={e => setNumeroLote(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Número de lote</label>
                            {numerolote.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.muestreocheck ? productoMap?.muestreo : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="number" className={`form-control ${productoMap?.muestreocheck !== undefined ? (productoMap?.muestreocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                value={volumen} onChange={e => setVolumen(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Volumen (Litros)</label>
                        </div>
                        {volumen.length <= 0 ? <>
                            <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                        <span className='text-danger'>{productoMap?.muestreocheck ? productoMap?.muestreo : ''}</span>
                    </div>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-2">
                            <input type="number" min='0' className={`form-control ${productoMap?.muestreocheck !== undefined ? (
                                productoMap?.muestreocheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                id="floatingInput" placeholder='Contenido Alcohólico'
                                value={contenidoalcoholico} onChange={e => setContenidoAlcoholico(e.target.valueAsNumber)}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <Tooltip title={`Contenido Alcohólico`} arrow>
                                <label htmlFor='floatingInput'>% Alc. Vol.</label>
                            </Tooltip>
                        </div>
                        {contenidoalcoholico < 35 || contenidoalcoholico > 55 ?
                            <span className='text-danger'>El rango debe de ser de 35% a 55%</span> : ''
                        }
                        {/*contenidoalcoholico.length <= 0 ? <>
                            <span className='text-danger'>Campo obligatorio</span> <br /></> : ''*/}
                        <span className='text-danger'>{productoMap?.muestreocheck ? productoMap?.muestreo : ''}</span>
                    </div>
                    <div className='col-md-3'><br />
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.muestreocheck !== undefined ? (productoMap?.muestreocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Contenido neto x botella'
                                value={analisis} onChange={e => setAnalisis(e.target.value)}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <label htmlFor='floatingInput'>Análisis de laboratorio</label>
                            {/*analisis.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''*/}
                            <span className='text-danger'>{productoMap?.muestreocheck ? productoMap?.muestreo : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-5'><br />
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.muestreocheck !== undefined ? (productoMap?.muestreocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Contenido neto x botella'
                                value={informacionadicional} onChange={e => setInformacionAdicional(e.target.value)}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <label htmlFor='floatingInput'>Información adicional</label>
                            {/*informacionadicional.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''*/}
                            <span className='text-danger'>{productoMap?.muestreocheck ? productoMap?.muestreo : ''}</span>
                        </div>
                    </div>

                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-start mt-1'>
                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-start'>
                            <input className={`form-check-input ${productoMap?.muestreocheck !== undefined ? (
                                productoMap?.muestreocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                checked={ajuste} id='produccionsuspencion'
                                name="produccionsuspencion"
                                onChange={e => { setAjuste(e.target.checked), setMezcla(false) }} />
                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                Por Ajuste (Reducción del grado
                            </label><br />
                            <label className="form-check-label ms-3" htmlFor="flexCheckChecked">
                                alcohólico)
                            </label>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-start mt-1'>
                            <input className={`form-check-input ${productoMap?.muestreocheck !== undefined ? (
                                productoMap?.muestreocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                checked={pmezcla} id='produccionreactivacion'
                                name="produccionreactivacion"
                                onChange={e => { setMezcla(e.target.checked), setAjuste(false) }}
                            />
                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                Por Mezcla (unión de lotes,
                            </label><br /> <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                misma categoria y clase)
                            </label><br />
                        </div>
                        {/*(ajuste == false && pmezcla==false)&&
                            <span className='text-danger'>Seleccione un tipo de muestreo</span>
                        
                        */}
                    </div>
                </div>
            </FormGroup>
            {
                !editar ?
                    <Fragment>
                        {fc_31ProductosMuestreoMap?.length === 0 ? (
                            <Fragment>
                                <div className='col-md-3'></div>
                                <div className='text-center'>
                                    <button className='btn btn-success col-md-3' onClick={botonAgregar}>Agregar producto</button>
                                </div>
                                <br />
                            </Fragment>) : ''}
                    </Fragment>
                    : (
                        <Fragment>
                            <div className='row'>
                                <div className='col-md-3'></div>
                                <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar producto</button>
                                <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                            </div>
                            <br />
                        </Fragment>
                    )
            }
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>
                {/*<div className='col-12 text-end'>
                    <Button onClick={e => { evento() }} className='btn btn-success text-end' disabled={!mezcla}> Mezclar Productos </Button><br />
                </div><br />*/}

                <div className='col-12'><br />
                    <div style={{ height: (130 + (rows?.length * 50)), width: '103%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            //checkboxSelection={true}
                            //disableSelectionOnClick
                            /*onSelectionModelChange={(id) => {
                                idsParaAsignar = id
                            }}*/
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />

                    </div><br /><br /><br />
                </div>
            </div>

        </>
    )

}
export default TablaProductoMuestreo